import { ActionItem } from '@/components_v2/ContextMenu';
import FilterContextMenu from '@/components_v2/FilterContextMenu';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import Popup from 'reactjs-popup';

import ItemExtra from './components/ItemExtra';
import { TriggerProps } from './interfaces';

// Filter titles come from the backend (already in Portuguese); this maps the
// known labels to a local translation key, falling back to the backend title
// for any filter not covered here.
const filterTitleTranslationKeys: Record<string, string> = {
  Local: 'common.local',
  Responsável: 'filter.responsible',
  Equipes: 'filter.teams',
  'Checklist (Template)': 'filter.checklist_template',
  Pergunta: 'gallery.question',
  'Agrupador de Locais': 'filter.local_group',
};

const FilterTrigger: React.FC<TriggerProps> = ({ filter }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const { t } = useTranslation();

  const translationKey = filterTitleTranslationKeys[filter.title];
  const filterTitle = translationKey ? t(translationKey) : filter.title;

  return (
    <Popup
      nested
      trigger={
        <div style={{ width: isMobile ? '250px' : '450px' }}>
          <ActionItem
            text={filterTitle}
            extra={<ItemExtra filter={filter} />}
            icon={<></>}
            clickable
            hasChevron
          />
        </div>
      }
      position={['right center', 'left center', 'bottom center', 'left bottom']}
      closeOnDocumentClick
      arrow={false}
      on={['click']}
    >
      <FilterContextMenu filter={filter} />
    </Popup>
  );
};

export default FilterTrigger;
